import { render, staticRenderFns } from "./MenuButtonClose.vue?vue&type=template&id=05a52cb2&scoped=true&functional=true"
var script = {}
import style0 from "./MenuButtonClose.vue?vue&type=style&index=0&id=05a52cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "05a52cb2",
  null
  
)

export default component.exports